import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row justify-content-center wow fadeInUp" }
const _hoisted_2 = { class: "col-md-12" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h4", { class: "title mb-4 text-center" }, "Sélectionner une table", -1)
const _hoisted_4 = { class: "list-tables" }
const _hoisted_5 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CustomModal = _resolveComponent("CustomModal")!

  return (_openBlock(), _createBlock(_component_CustomModal, { modalsize: 'modal-sm' }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.storeData?.tables, (table, indexT) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "item-table",
                onClick: ($event: any) => ($options.selectTable(table))
              }, [
                _createElementVNode("p", null, _toDisplayString(table.table_number), 1)
              ], 8, _hoisted_5))
            }), 256))
          ])
        ])
      ])
    ]),
    _: 1
  }))
}